import emailModelValidator from './email';

export default emailModelValidator;
